import React from "react";
import { useAuthProvider } from "@cloudpremise/portal_core";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Usernav from "@cloudpremise/portal_core/src/themes/mui/examples/Usernav";
import NotificationItem from "@cloudpremise/portal_core/src/themes/mui/examples/Items/NotificationItem";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Popover from '@mui/material/Popover';
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

import {
  navbar,
  navbarMobile,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar/styles";

import {
  useMaterialUIController,
  setMiniSidenav
} from "@cloudpremise/portal_core/src/themes/mui/context";
import { ReactComponent as MenuOpenIcon } from '@cloudpremise/portal_core/src/themes/mui/assets/icons/menu_open_right.svg';

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import "../styles/navbar.scss";

import Config from "../../../../Config";
const cdnUrl = Config.getCdnUrl();

const Navbar = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const { isMini, light } = props;
    const [controller, dispatch] = useMaterialUIController();
    const {
        user,
        darkMode,
        miniSidenav,
        transparentNavbar
    } = controller;
    const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
    
    const userImage = cdnUrl + "/assets/img/portal.jpg";
    const defaultState = {
        search: "",
        usernavOpen: false,
        anchorEl: null,
        showNotifications: false
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function onUsernav(event, status = true){
        setState({
            usernavOpen: status,
            anchorEl: (status ? event.currentTarget : null)
        })
    }
    function onNotificationsMenu(event, status = true){
        setState({
            showNotifications: status,
            anchorEl: (status ? event.currentTarget : null)
        })
    }
    const iconsStyle = ({
        palette: { dark, white, text },
        functions: { rgba },
    }: {
        palette: any;
        functions: any;
    }) => ({
        color: () => {
        let colorValue = light || darkMode ? white.main : dark.main;
    
        if (transparentNavbar && !light) {
            colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
        }
    
        return colorValue;
        },
    });
    if(!authorized){
        return null;
    }
    return (
        <MDBox className="custom-navbar">
            <MDBox>
                <Grid container spacing={3} mb={2}>
                    <Grid item xs={9} md={9} lg={9} className="navbar-left-container">
                        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
                            <IconButton sx={navbarMobileMenu} onClick={handleMiniSidenav} size="small" disableRipple style={{marginRight: "10px"}}>
                                <Icon fontSize="medium" sx={iconsStyle}>
                                    menu
                                </Icon>
                            </IconButton>
                            <MDInput
                                name="search"
                                type="text"
                                // label="Search"
                                placeholder="Search (e.g., Plugin, User, Config)..."
                                fullWidth
                                value={state.search}
                                onChange={(e) => handleChange(e, "search")}
                                required
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={3} md={3} lg={3} sx={{textAlign: "right"}} className="navbar-right-container">
                        <IconButton
                            size="medium"
                            onClick={onNotificationsMenu}
                        >
                            <NotificationsNoneOutlinedIcon />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={onUsernav}
                        >
                            <Person2OutlinedIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </MDBox>
            <Usernav
                open={state.usernavOpen}
                onClose={(event) => onUsernav(event, false)}
                userImage={userImage}
            />
            <Popover
                id='usernav-popover'
                open={state.usernavOpen}
                anchorEl={state.anchorEl}
                onClose={(event) => onUsernav(event, false)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                >
                
            </Popover>
            <Menu
                anchorEl={state.anchorEl}
                anchorReference={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                open={state.showNotifications}
                onClose={(event) => onNotificationsMenu(event, false)}
            >
                <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
                <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
            </Menu>
        </MDBox>
    )
};

export default Navbar;